module.exports = __webpack_public_path__ + "img/stickers_0015_thumbsup.452de152.png";